import { useQuery } from '@tanstack/react-query';
import { settlementsApi } from '../api/settlementsApi';

// TCS-staff: read a chosen merchant's settlements by id (COLLECTIVE-only endpoint).
export const useMerchantSettlements = (tenantId: string) =>
  useQuery({
    queryKey: ['settlements', tenantId],
    queryFn: () => settlementsApi.listByMerchant(tenantId),
    staleTime: 60 * 1000,
    enabled: !!tenantId,
  });

// Merchant-scoped: the caller's OWN settlements (MERCHANT-only endpoint, id from JWT).
export const useOwnSettlements = (enabled: boolean) =>
  useQuery({
    queryKey: ['settlements', 'me'],
    queryFn: () => settlementsApi.listOwn(),
    staleTime: 60 * 1000,
    enabled,
  });
